import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getConfigPtMonAnalogico } from './services'

const initialState: any = {
  status: "",
  data: {}
}

export const actionGetConfigPtMonAnalogico: any = createAsyncThunk<any, any>(
  "ACTION_GET_CONFIG_PT_MON_ANALOGICO",
  async (data, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
          },
          entrada
        }
      },
    } = getState()
    return getConfigPtMonAnalogico({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    })
  }
)

const sliceGetConfigPtMonAnalogico = createSlice({
  name: "GET_CONFIG",
  initialState,
  reducers: {
    actionResetGetConfigPtMonAnalogico: (state) => {
      state.data = {}
    }
  },
  extraReducers: {
    [actionGetConfigPtMonAnalogico.pending]: (state) => {
      state.status = "loading"
    },
    [actionGetConfigPtMonAnalogico.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = {
        ...payload,
        hrMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[0],
        minMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[1],
        hrMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[0],
        minMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[1],
      }
    },
    [actionGetConfigPtMonAnalogico.rejected]: (state, err) => {
      console.log(err)
      state.status = "error"
    },
  }
})

export default sliceGetConfigPtMonAnalogico.reducer
export const { actionResetGetConfigPtMonAnalogico } = sliceGetConfigPtMonAnalogico.actions